import axios from 'axios';
import { toast } from 'react-toastify';
import { useMutation, useQueryClient } from 'react-query';

const useCreateProjectIdCard = ({ onModalClose }) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(
    async ({idCardData, onSuccessCallback}) => {
      return await axios.post(`/idcards/project`, idCardData);
    },
    {
      onSuccess: (res, {onSuccessCallback}) => {
        queryClient.invalidateQueries('idCards', { exact: true });
        queryClient.invalidateQueries('projects', { exact: true });
        onSuccessCallback();
        toast.success('Project Id Card Created', {
          position: toast.POSITION.TOP_LEFT,
        });
        onModalClose();
      },
      onError: (err) => {
        let errorMsg = err?.response?.data?.error || err.message;
        toast.error(`${errorMsg}`, {
          position: toast.POSITION.TOP_LEFT,
        });
      },
    }
  );
  return {
    createProjectIdCard: mutate,
    isLoading,
  };
};

export default useCreateProjectIdCard;
